export const tcsmColors = {
    green: '#478134',
    yellow: '#EDB529',
    red: '#AD3333',
    purple: '#5E14A9',
    blue: '#0F6FA8',
    darkBlue: '#174983',
    lightBlue: '#A1B7D0',
    // Greys the higher the number the lighter the grey
    greyOne: '#303030',
    greyTwo: '#555555',
    greyThree: '#707070',
    greyFour: '#BBBBBB',
    greyFive: '#E1E1E1',
    greySix: '#F2F2F2',
    greySeven: '#F9F9F9',
    white: '#ffffff',
    black: '#000000',
};

export const disabledGrey = tcsmColors.greyFive;